import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  // MobileStepper,
  // Paper,
  Snackbar,
  Typography,
  Button,
  Card,
  Divider,
  TextField,
  MenuItem,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import usePageTitle from "../../pageTitle";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";

function CartPage() {
  const [pageTitle, setPageTitle] = useState("WebStore");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshCart, setRefreshCart] = useState(false);
  const [carts, setCarts] = useState([]);
  const [cartGroups, setCartGroups] = useState([]);

  useEffect(() => {
    let sessionRef = null;
    let session = localStorage.getItem(AppConfig.session_storage_label);
    if (session !== null) {
      sessionRef = JSON.parse(session).reference;
    }

    if (sessionRef === null) {
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`webstore/carts/${ref}/${sessionRef}/get.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPageTitle(`Laddar Africa | ${result.data.data.webstore.title}`);
            setCartGroups(result.data.data.carts);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshCart]);

  function getCartDetails() {
    const basket = localStorage.getItem(AppConfig.cart_storage_label);
    if (basket === null) {
      return null;
    }
    return basket;
  }

  useEffect(() => {
    let tempCarts = [];
    cartGroups.every((crt, index) => {
      let tPrice = 0;
      crt.products.every((prd) => {
        tPrice += prd.amount * prd.quantity;
        return true;
      });

      let bsk = {
        reference: crt.reference,
        total_price: tPrice,
        currency: crt.currency,
        products: crt.products,
      };
      tempCarts.push(bsk);
      return true;
    });

    setCarts(tempCarts);
  }, [cartGroups]);

  // function removeProduct(campaignIndex, productIndex) {
  //   const xcart = getCartDetails();
  //   if (xcart === null) {
  //     return;
  //   }

  //   const basket = JSON.parse(xcart);
  //   let cart = basket.carts[campaignIndex];
  //   if (cart === null) {
  //     return;
  //   }

  //   if (basket.carts[campaignIndex].products[productIndex] === null) {
  //     return;
  //   }

  //   basket.carts[campaignIndex].products.splice(productIndex, 1);
  //   if (basket.carts[campaignIndex].products.length === 0) {
  //     basket.carts.splice(campaignIndex, 1);
  //   }

  //   // Update cart storage
  //   localStorage.setItem(AppConfig.cart_storage_label, JSON.stringify(basket));
  //   setRefreshCart(!refreshCart);

  //   if (basket.carts.length > 0) {
  //     setErrMsg("Product removed from cart.");
  //     setSeverity("success");
  //     setOpen(true);
  //     return;
  //   }
  // }

  async function removeProduct(ref) {
    setShowLoading(true);
    await axios
      .get(`webstore/carts/products/${ref}/remove.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setErrMsg("Product removed from cart.");
          setSeverity("success");
          setOpen(true);

          setRefreshCart(!refreshCart);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred.");
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={15}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          <Box sx={{ margin: "5px auto", maxWidth: "800px" }}>
            <Box
              sx={{
                mt: { xs: 3, md: 5 },
                mb: 3,
              }}
            >
              <Button
                startIcon={<Icon>arrow_back_rounded</Icon>}
                sx={{ ml: "-8px" }}
                onClick={() => {
                  window.history.back();
                }}
              >
                Continue Shopping
              </Button>
            </Box>
            {carts.length > 0 ? (
              <Box mb={3}>
                {carts.map((grp, cIndex) => (
                  <Box mt={3} mb={3}>
                    <Paper elevation={3}>
                      <Box p={3}>
                        <Box>
                          {/* <Box>
                            <Typography variant="h6" fontSize={18}>
                              {grp.name}
                            </Typography>
                          </Box>
                          <Divider /> */}
                          <Box mt={0}>
                            <List disablePadding>
                              {grp.products.map((product, pIndex) => (
                                <ListItem
                                  key={product.reference}
                                  sx={{ py: 1, px: 0 }}
                                >
                                  <ListItemIcon>
                                    <img
                                      // src="https://placehold.co/600x400.png"
                                      src={`${AppConfig.api_media_url}${product.image}`}
                                      alt="img"
                                      width="48px"
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    sx={{ mr: 2 }}
                                    primary={product.name}
                                    secondary={
                                      <Box mt={1}>
                                        <Typography fontSize={10}>
                                          {product.variants.map((variant) => (
                                            <>
                                              {variant.variant_title}
                                              :&nbsp;{variant.option_title}
                                              &nbsp;|&nbsp;
                                            </>
                                          ))}
                                          {`Quantity: ${product.quantity}`}
                                        </Typography>
                                      </Box>
                                    }
                                  />
                                  <Box>
                                    <Box mt={1} align="right">
                                      <Typography
                                        variant="body1"
                                        fontWeight="medium"
                                      >
                                        <small>{grp.currency}</small>
                                        {(
                                          (product.amount * product.quantity) /
                                          100
                                        ).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </Typography>
                                    </Box>
                                    <Box align="right" mt={-1}>
                                      <IconButton
                                        variant="outlined"
                                        onClick={() => {
                                          navigate(
                                            `/ws/product/${product.reference}`
                                          );
                                        }}
                                      >
                                        <Icon color="" fontSize="small">
                                          edit_note
                                        </Icon>
                                      </IconButton>
                                      <IconButton
                                        variant="outlined"
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              "Remove this product?"
                                            ) === true
                                          ) {
                                            removeProduct(product.cart_reference);
                                          }
                                        }}
                                      >
                                        <Icon color="error" fontSize="small">
                                          cancel
                                        </Icon>
                                      </IconButton>
                                    </Box>
                                  </Box>
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                          <Box mt={2}>
                            <Divider />
                          </Box>
                          <Box mt={3} align="right">
                            <Typography variant="caption" fontSize={18}>
                              <small>Total:</small>{" "}
                              <small>{grp.currency}</small>
                              {(grp.total_price / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                            <Box mt={3}>
                              <Button
                                variant="outlined"
                                startIcon={<Icon>payment</Icon>}
                                onClick={() => {
                                  navigate(`/ws/checkout/${grp.reference}`);
                                }}
                              >
                                Checkout
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                ))}
              </Box>
            ) : (
              <Paper elevation={3}>
                <Box p={5} align="center">
                  <Box>
                    <Icon color="primary">shopping_cart</Icon>
                  </Box>
                  <Typography variant="caption" fontSize={18}>
                    Cart is empty.
                  </Typography>
                </Box>
              </Paper>
            )}
          </Box>
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default CartPage;
